import React, { useEffect } from "react";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid, Paper } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import UsersRequests from "services/users";
import { useParams } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import DateRangeIcon from "@material-ui/icons/DateRange";
import moment from "jalali-moment";
import ReactJson from "react-json-view";

const useStyles = makeStyles((theme) => ({
  formTitleContainer: {
    padding: "1rem",
    fontWeight: "bold",
    fontSize: "17px",
    color: theme.palette.primary.main,
  },
  Title: {
    padding: "0.8rem",
    backgroundColor: theme.palette.grey[200],
    fontWeight: "bold",
  },
  userInput: {
    padding: "0.8rem",
    fontWeight: "bold",
    minHeight: "45.61px",
  },
}));

const mappedActions = {
  Create: "ساخت",
  Update: "ویرایش",
  Delete: "حذف",
};

const AdminLogDetailsContainer = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { adminLog } = useSelector(({ users }) => users);
  const { id } = useParams();

  useEffect(() => {
    dispatch(UsersRequests.getAdminLogById(id));
  }, [id, dispatch]);

  return (
    <GridContainer>
      <Grid item md={8} xs={12}>
        <Paper>
          <Box className={classes.formTitleContainer}>بعد</Box>
          <ReactJson
            src={adminLog?.after}
            style={{
              direction: "ltr",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              margin: "16px",
            }}
          />
          <br />
        </Paper>
        <br />
        {adminLog?.before && (
          <Paper>
            <Box className={classes.formTitleContainer}>قبل</Box>
            <ReactJson
              src={adminLog?.before}
              style={{
                direction: "ltr",
                padding: "20px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                margin: "16px",
              }}
            />
            <br />
          </Paper>
        )}
      </Grid>
      <Grid item md={4} xs={12}>
        <Paper elevation={3}>
          <Box className={classes.formTitleContainer}>جزئیات ادمین</Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              نام و نام خانوادگی
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {adminLog?.admin?.fullName}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              کد ملی
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {adminLog?.admin?.nationalCode}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              کد پرسنلی
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {adminLog?.admin?.personnelCode}
          </Box>
        </Paper>
        <br />
        {adminLog?.targetUser && (
          <Paper elevation={3}>
            <Box className={classes.formTitleContainer}>جزئیات کاربر هدف</Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                نام و نام خانوادگی
              </Box>
            </Box>
            <Box className={classes.userInput} textAlign={"right"}>
              {adminLog?.targetUser?.fullName}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                کد ملی
              </Box>
            </Box>
            <Box className={classes.userInput} textAlign={"right"}>
              {adminLog?.targetUser?.nationalCode}
            </Box>
            <Box className={classes.Title}>
              <Box display={"flex"} alignItems={"center"}>
                کد پرسنلی
              </Box>
            </Box>
            <Box className={classes.userInput} textAlign={"right"}>
              {adminLog?.targetUser?.personnelCode}
            </Box>
          </Paper>
        )}
        <br />
        <Paper elevation={3}>
          <Box className={classes.formTitleContainer}>جزئیات لاگ</Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <VpnKeyIcon style={{ marginLeft: "5px" }} />
              شناسه ورودی:
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {adminLog?._id}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <DateRangeIcon style={{ marginLeft: "5px" }} />
              تاریخ :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {adminLog
              ? moment(adminLog.createdAt)
                  .locale("fa")
                  .format("HH:mm:ss  YYYY/MM/DD ")
              : null}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              نوع عملیات
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {mappedActions[adminLog?.action]}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              نام پایگاه داده
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {adminLog?.dbName}
          </Box>
        </Paper>
      </Grid>
    </GridContainer>
  );
};

export default AdminLogDetailsContainer;
